export class PuntoPais {

    idPais: number;
    nom_pais: string;

    constructor(data: any) {
        this.idPais = data['cod_pais'];
        this.nom_pais = data['nom_pais'];
    }

}